import { combineReducers } from "redux";
import productReducer from "./productReducer";
import cartReducer from "./cartReducer";
import orderReducer from "./orderReducer"

const rootReducer = combineReducers({
  productReducer,
  cartReducer,
  orderReducer
});

export default rootReducer;


